import { DataSet, DataView } from "@visactor/vdataset";

import { array, isValid, isNil, isString, isEmpty, isArray, isEqual } from "@visactor/vutils";

import { BaseComponent } from "../base/base-component";

import { calcLayoutNumber } from "../../util/space";

import { isAggrSpec } from "./utils";

import { getFirstSeries } from "../../util";

import { arrayParser } from "../../data/parser/array";

export class BaseMarker extends BaseComponent {
    constructor() {
        super(...arguments), this.layoutType = "none", this._layoutOffsetX = 0, this._layoutOffsetY = 0;
    }
    getRelativeSeries() {
        return this._relativeSeries;
    }
    getMarkerData() {
        return this._markerData;
    }
    static _getMarkerCoordinateType(markerSpec) {
        return "cartesian";
    }
    static getSpecInfo(chartSpec) {
        const markerSpec = chartSpec[this.specKey];
        if (isEmpty(markerSpec)) return;
        if (!isArray(markerSpec) && !1 !== markerSpec.visible && this._getMarkerCoordinateType(markerSpec) === this.coordinateType) return [ {
            spec: markerSpec,
            specPath: [ this.specKey ],
            specInfoPath: [ "component", this.specKey, 0 ],
            type: this.type
        } ];
        const specInfos = [];
        return array(markerSpec).forEach(((m, i) => {
            !1 !== m.visible && this._getMarkerCoordinateType(m) === this.coordinateType && specInfos.push({
                spec: m,
                specPath: [ this.specKey, i ],
                specInfoPath: [ "component", this.specKey, i ],
                type: this.type
            });
        })), specInfos;
    }
    created() {
        super.created(), this._bindSeries(), this._initDataView(), this.initEvent();
    }
    _getAllRelativeSeries() {
        return {
            getRelativeSeries: () => this._relativeSeries,
            getStartRelativeSeries: () => this._startRelativeSeries,
            getEndRelativeSeries: () => this._endRelativeSeries
        };
    }
    _getFieldInfoFromSpec(dim, spec, relativeSeries) {
        const specKeyByDim = {
            x: "xField",
            y: "yField",
            radius: "valueField",
            angle: "categoryField",
            areaName: "nameField"
        };
        return isString(spec) && isAggrSpec(spec) ? {
            field: relativeSeries.getSpec()[specKeyByDim[dim]],
            aggrType: spec
        } : spec;
    }
    _processSpecByDims(dimSpec) {
        const relativeSeries = this._relativeSeries, dimMap = {};
        return dimSpec.forEach((d => dimMap[d.dim] = this._getFieldInfoFromSpec(d.dim, d.specValue, relativeSeries))), 
        Object.assign(Object.assign({}, dimMap), this._getAllRelativeSeries());
    }
    _processSpecCoo(spec) {
        var _a;
        let option;
        return (null !== (_a = spec.coordinates) && void 0 !== _a ? _a : array(spec.coordinate)).map((coordinate => {
            const refRelativeSeries = this._getSeriesByIdOrIndex(coordinate.refRelativeSeriesId, coordinate.refRelativeSeriesIndex);
            if ("cartesian" === this.coordinateType) {
                const {xField: xField, yField: yField} = refRelativeSeries.getSpec(), {xFieldDim: xFieldDim, xFieldIndex: xFieldIndex, yFieldDim: yFieldDim, yFieldIndex: yFieldIndex} = coordinate;
                let bindXField = xField;
                isValid(xFieldIndex) && (bindXField = array(xField)[xFieldIndex]), xFieldDim && array(xField).includes(xFieldDim) && (bindXField = xFieldDim);
                let bindYField = yField;
                isValid(yFieldIndex) && (bindYField = array(yField)[yFieldIndex]), yFieldDim && array(yField).includes(yFieldDim) && (bindYField = yFieldDim), 
                option = Object.assign({
                    x: void 0,
                    y: void 0
                }, this._getAllRelativeSeries()), isString(coordinate[bindXField]) && isAggrSpec(coordinate[bindXField]) ? option.x = {
                    field: bindXField,
                    aggrType: coordinate[bindXField]
                } : option.x = array(bindXField).map((field => coordinate[field])), isString(coordinate[bindYField]) && isAggrSpec(coordinate[bindYField]) ? option.y = {
                    field: bindYField,
                    aggrType: coordinate[bindYField]
                } : option.y = array(bindYField).map((field => coordinate[field]));
            } else if ("polar" === this.coordinateType) {
                const {valueField: radiusField, categoryField: angleField} = refRelativeSeries.getSpec(), {angleFieldDim: angleFieldDim, angleFieldIndex: angleFieldIndex} = coordinate;
                let bindAngleField = angleField;
                isValid(angleFieldIndex) && (bindAngleField = array(angleField)[angleFieldIndex]), 
                angleFieldDim && array(angleField).includes(angleFieldDim) && (bindAngleField = angleFieldDim);
                const bindRadiusField = radiusField;
                option = Object.assign({
                    angle: void 0,
                    radius: void 0
                }, this._getAllRelativeSeries()), isString(coordinate[bindAngleField]) && isAggrSpec(coordinate[bindAngleField]) ? option.angle = {
                    field: bindAngleField,
                    aggrType: coordinate[bindAngleField]
                } : option.angle = array(bindAngleField).map((field => coordinate[field])), isString(coordinate[bindRadiusField]) && isAggrSpec(coordinate[bindRadiusField]) ? option.radius = {
                    field: bindRadiusField,
                    aggrType: coordinate[bindRadiusField]
                } : option.radius = array(bindRadiusField).map((field => coordinate[field]));
            }
            return option.getRefRelativeSeries = () => refRelativeSeries, option;
        }));
    }
    _getRelativeDataView() {
        if (this._specifiedDataSeries) {
            let resultData = [];
            array(this._specifiedDataSeries).forEach((series => {
                resultData = resultData.concat(series.getViewData().latestData);
            }));
            const dataSet = new DataSet;
            return dataSet.registerParser("array", arrayParser), new DataView(dataSet).parse(resultData, {
                type: "array"
            });
        }
        return this._relativeSeries.getViewData();
    }
    updateLayoutAttribute() {
        var _a, _b, _c;
        if (null === (_a = this._spec.visible) || void 0 === _a || _a) {
            if (!this._markerComponent) {
                const markerComponent = this._createMarkerComponent();
                markerComponent.name = null !== (_b = this._spec.name) && void 0 !== _b ? _b : this.type, 
                markerComponent.id = null !== (_c = this._spec.id) && void 0 !== _c ? _c : `${this.type}-${this.id}`, 
                this._markerComponent = markerComponent, this.getContainer().add(this._markerComponent), 
                this._markerComponent.on("*", ((event, type) => {
                    this._delegateEvent(this._markerComponent, event, type, null, this.getMarkerData.bind(this));
                }));
            }
            this._markerLayout();
        }
        super.updateLayoutAttribute();
    }
    _getSeriesByIdOrIndex(seriesUserId, seriesIndex) {
        var _a, _b;
        let series;
        return series = null === (_a = this._option.getSeriesInUserIdOrIndex(isValid(seriesUserId) ? [ seriesUserId ] : [], [ seriesIndex ])) || void 0 === _a ? void 0 : _a[0], 
        series || (series = null !== (_b = this._relativeSeries) && void 0 !== _b ? _b : this._getFirstSeries()), 
        series;
    }
    _bindSeries() {
        const spec = this._spec;
        this._relativeSeries = this._getSeriesByIdOrIndex(spec.relativeSeriesId, spec.relativeSeriesIndex), 
        this._startRelativeSeries = this._getSeriesByIdOrIndex(spec.startRelativeSeriesId, spec.startRelativeSeriesIndex), 
        this._endRelativeSeries = this._getSeriesByIdOrIndex(spec.endRelativeSeriesId, spec.endRelativeSeriesIndex), 
        spec.specifiedDataSeriesIndex && "all" === spec.specifiedDataSeriesIndex || spec.specifiedDataSeriesId && "all" === spec.specifiedDataSeriesId ? this._specifiedDataSeries = this._option.getAllSeries() : (spec.specifiedDataSeriesIndex || spec.specifiedDataSeriesId) && (this._specifiedDataSeries = this._getSeriesByIdOrIndex(spec.specifiedDataSeriesId, spec.specifiedDataSeriesIndex));
    }
    initEvent() {
        "cartesian" !== this._relativeSeries.coordinate && (this._relativeSeries.event.on("zoom", this._markerLayout.bind(this)), 
        this._relativeSeries.event.on("panmove", this._markerLayout.bind(this)), this._relativeSeries.event.on("scroll", this._markerLayout.bind(this)));
    }
    onRender(ctx) {}
    changeRegions(regions) {}
    clear() {
        super.clear(), this._firstSeries = null;
    }
    _getFirstSeries() {
        var _a;
        if (this._firstSeries) return this._firstSeries;
        const firstSeries = getFirstSeries(this._regions);
        return firstSeries ? (this._firstSeries = firstSeries, firstSeries) : (null === (_a = this._option) || void 0 === _a || _a.onError("need at least one series"), 
        null);
    }
    _getNeedClearVRenderComponents() {
        return [ this._markerComponent ];
    }
    onLayoutStart(layoutRect, chartViewRect, ctx) {
        isNil(this._spec.offsetX) || (this._layoutOffsetX = calcLayoutNumber(this._spec.offsetX, chartViewRect.width, chartViewRect)), 
        isNil(this._spec.offsetY) || (this._layoutOffsetY = calcLayoutNumber(this._spec.offsetY, chartViewRect.height, chartViewRect)), 
        super.onLayoutStart(layoutRect, chartViewRect, ctx);
    }
    _compareSpec(spec, prevSpec) {
        const result = super._compareSpec(spec, prevSpec);
        return isEqual(prevSpec, spec) || (result.reRender = !0, result.reMake = !0, result.change = !0), 
        result;
    }
}
//# sourceMappingURL=base-marker.js.map
